import {configureStore, combineReducers} from '@reduxjs/toolkit'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {reducer as authReducer} from '../modules/auth/AuthRedux'
import {reducer as commonReducer} from '../modules/common/CommonRedux'

const rootReducer = combineReducers({
  auth: authReducer,
  common: commonReducer,
})

const persistedReducer = persistReducer({key: 'root', storage}, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>

const persistor = persistStore(store)

export {store, persistor}
